var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletpurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6587 4.66371V2.66501C12.6587 2.48832 12.5886 2.31886 12.4636 2.19391C12.3387 2.06897 12.1692 1.99878 11.9925 1.99878H3.33149C2.9781 1.99878 2.63918 2.13916 2.38929 2.38905C2.13941 2.63893 1.99902 2.97785 1.99902 3.33124C1.99902 3.68464 2.13941 4.02355 2.38929 4.27344C2.63918 4.52333 2.9781 4.66371 3.33149 4.66371H13.325C13.5017 4.66371 13.6711 4.7339 13.7961 4.85885C13.921 4.98379 13.9912 5.15325 13.9912 5.32994V7.99487M13.9912 7.99487H11.9925C11.6391 7.99487 11.3002 8.13526 11.0503 8.38514C10.8004 8.63503 10.66 8.97395 10.66 9.32734C10.66 9.68073 10.8004 10.0196 11.0503 10.2695C11.3002 10.5194 11.6391 10.6598 11.9925 10.6598H13.9912C14.1679 10.6598 14.3374 10.5896 14.4623 10.4647C14.5873 10.3397 14.6574 10.1703 14.6574 9.99357V8.66111C14.6574 8.48441 14.5873 8.31495 14.4623 8.19001C14.3374 8.06507 14.1679 7.99487 13.9912 7.99487Z",
    stroke: "#DAB2FF",
    strokeWidth: 1.33247,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99902 3.33105V12.6583C1.99902 13.0117 2.13941 13.3506 2.38929 13.6005C2.63918 13.8504 2.9781 13.9908 3.33149 13.9908H13.325C13.5017 13.9908 13.6711 13.9206 13.7961 13.7956C13.921 13.6707 13.9912 13.5012 13.9912 13.3245V10.6596",
    stroke: "#DAB2FF",
    strokeWidth: 1.33247,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletpurple);
export default __webpack_public_path__ + "static/media/walletpurple.f54f659ede2ca23f047e2d42ee4f9ab7.svg";
export { ForwardRef as ReactComponent };